import axios from "axios";

// Configurar el dominio base para Axios según el entorno
const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_BASE_URL = isLocal
  ? "http://localhost/Photobook_QR"
  : "https://photobook.alavuelta360.com.mx";

axios.defaults.baseURL = API_BASE_URL;

console.log("🌐 API Base URL:", axios.defaults.baseURL);

// Configurar cache agresivo para optimizar hosting
const photoCache = {
  data: null,
  timestamp: 0,
  ttl: 30000, // 30 segundos de cache
};

// Obtener fotos desde el backend de Hostinger con paginación y cache
export async function getPhotos(limit = 50, offset = 0, useCache = true) {
  // Verificar cache si está habilitado
  if (
    useCache &&
    photoCache.data &&
    Date.now() - photoCache.timestamp < photoCache.ttl
  ) {
    console.log("📦 Usando fotos en cache");
    return photoCache.data;
  }

  try {
    const response = await axios.get("/api/photo.php", {
      params: { limit, offset },
      timeout: 10000, // 10 segundos timeout
      headers: {
        "Cache-Control": "max-age=300", // 5 minutos en browser cache
      },
    });

    // Validar que la respuesta sea un array
    const data = Array.isArray(response.data) ? response.data : [];

    // Guardar en cache
    photoCache.data = data;
    photoCache.timestamp = Date.now();

    console.log(`📸 ${data.length} fotos cargadas desde servidor`);
    return data;
  } catch (error) {
    console.error("Error al cargar fotos:", error);
    // Si hay datos en cache, usarlos aunque esté expirado
    if (photoCache.data && Array.isArray(photoCache.data)) {
      console.log("⚠️ Usando cache expirado por error de red");
      return photoCache.data;
    }
    // Retornar array vacío en caso de error total
    return [];
  }
}

// Limpiar cache manualmente
export function clearPhotoCache() {
  photoCache.data = null;
  photoCache.timestamp = 0;
}

// Subir una foto al backend de Hostinger con progreso
export async function uploadPhoto(formData, onProgress) {
  try {
    const response = await axios.post("/api/photo.php", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 60000, // 60 segundos para uploads grandes
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });

    // Limpiar cache para que se recarguen las fotos
    clearPhotoCache();

    return response.data;
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      throw new Error("Tiempo de espera agotado. La imagen es muy grande.");
    }
    throw error;
  }
}

// Registrar un like en el backend de Hostinger
export async function likePhoto(photo_id, user_id) {
  const response = await axios.post("/api/likes.php", { photo_id, user_id });
  return response.data;
}

// Obtener comentarios de una foto desde el backend de Hostinger
export async function getPhotoComments(photo_id) {
  const response = await axios.get(`/api/photo.php/${photo_id}/comments.php`);
  return response.data;
}

// Guardar un comentario en el backend de Hostinger
export async function addComment(photo_id, user_id, comment) {
  const response = await axios.post("/api/comments.php", {
    photo_id,
    user_id,
    comment,
  });
  return response.data;
}
